
import { useEffect, useState } from "react";
import LocalizedStrings, { LocalizedStringsMethods } from "react-localization";
import { DynamicFormControl } from "../../dynamic-form-definition";

/** Custom react hook to detect when a page has been translated */
export function useTranslateDetection() {
    const [translated, setTranslated] = useState<boolean>(false);
    const [currentLanguage, setCurrentLanguage] = useState<string>(document.documentElement.lang);

    useEffect(() => {
        const observer = new MutationObserver(function (event) {
            let updatedTranslate = document.documentElement.className.match('translated') != null;

            // Translation status has changed
            if (updatedTranslate !== translated) {
                setTranslated(updatedTranslate);
                setCurrentLanguage(document.documentElement.lang);
            }
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['class'],
            childList: false,
            characterData: false
        });
    }, [translated, setTranslated]);

    return {
        translated,
        currentLanguage
    }
}

export function localizeText(strings: LocalizedStringsMethods, text: string): { localization: string, hasMatch: boolean } {
    const regex = /\$\{localization\.(.*)\}/gm;
    const matches = text.matchAll(regex);
    let hasMatch = false;

    for (const match of matches) {
        const key = match[1];
        hasMatch = true;

        text = strings.getString(key);
    }

    return { localization: text, hasMatch: hasMatch };
}

export function getLocalizedStringMethods(control: DynamicFormControl, currentLanguage: string): LocalizedStringsMethods | null {
    let strings: LocalizedStringsMethods | null = null;

    if (control.localization != null) {
        const lang = currentLanguage;
        strings = new LocalizedStrings(control.localization);

        if (lang != null) {
            strings.setLanguage(lang);
        }
    }

    return strings;
}